import { render, staticRenderFns } from "./oneCallOil.vue?vue&type=template&id=0959ca38&scoped=true&"
import script from "./oneCallOil.vue?vue&type=script&lang=js&"
export * from "./oneCallOil.vue?vue&type=script&lang=js&"
import style0 from "./oneCallOil.vue?vue&type=style&index=0&id=0959ca38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0959ca38",
  null
  
)

export default component.exports